import React, { useState, useEffect } from 'react';
import { EditButton, Edit, Create, SimpleForm, TextInput, SelectInput, TopToolbar, ListButton, Toolbar, SaveButton } from 'react-admin';
import { Link } from 'react-router-dom';
import SortableTable from './components/SortableTable';
import { httpClient, publicBase } from './dataProvider';

const UserEditActions = () => (
    <TopToolbar>
        <ListButton />
    </TopToolbar>
);

const UserEditToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
);

export const UserList = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const url = `${publicBase}/users?_start=0&_end=10000`; // Fetch all for client-side sort
        httpClient(url)
            .then(({ json }) => {
                setUsers(json || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching users:', error);
                setLoading(false);
            });
    }, []);

    const columns = [
        { key: 'name', header: 'Name' },
        { key: 'surname', header: 'Surname' },
        { key: 'email', header: 'Email' },
        { key: 'company_name', header: 'Company' },
        { key: 'role_at_company', header: 'Role at Company' },
        { key: 'status', header: 'Status' },
        { key: 'created_at', header: 'Created At' },
        {
            key: 'actions',
            header: 'Actions',
            sortable: false,
            render: (record) => (
                <EditButton record={record} basePath="/users" />
            )
        }
    ];

    if (loading) return <p>Loading...</p>;

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h2>Users</h2>
                <Link
                    to="/users/create"
                    style={{
                        padding: '8px 16px',
                        backgroundColor: '#1976d2',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '4px',
                        fontSize: '14px',
                        fontWeight: '500'
                    }}
                >
                    Create
                </Link>
            </div>
            <SortableTable data={users} columns={columns} />
        </div>
    );
};

export const UserEdit = () => (
    <Edit title="Edit User" actions={<UserEditActions />}>
        <SimpleForm toolbar={<UserEditToolbar />}>
            <h2>Users</h2>
            <TextInput source="name" />
            <TextInput source="surname" />
            <TextInput source="email" required />
            <TextInput source="role" required />
            <TextInput source="company_name" label="Company Name" />
            <TextInput source="role_at_company" label="Role at Company" />
            <SelectInput
                source="status"
                choices={[
                    { id: 'requested', name: 'Requested' },
                    { id: 'approved', name: 'Approved' }
                ]}
                required
            />
            <TextInput source="admin_notes" label="Admin Notes" multiline rows={4} />
        </SimpleForm>
    </Edit>
);

export const UserCreate = () => (
    <Create title="Create User">
        <SimpleForm>
            <h2>Users</h2>
            <TextInput source="name" />
            <TextInput source="surname" />
            <TextInput source="email" />
        </SimpleForm>
    </Create>
);
